import { RESOURCES } from '../../types';

export const overview = {
  name: 'My mentor form',
  id: 1,
  description: 'Mentor form description',
  surveySchema: {
    title: 'Mentor Form',
    pages: [{ name: 'page1', elements: [] }],
  },
  entityCreated: {
    at: 'Thu Aug 02 2018 18:05:31 GMT+0000 (UTC)',
    by: 'User McUser',
  },
  entityUpdated: {
    at: 'Thu Aug 09 2018 08:46:00 GMT+0000 (UTC)',
    by: 'Useriko McUserico',
  },
  usedIn: [
    { id: 1, type: RESOURCES.COURSE, name: 'Some course 1' },
  ],
};
